import * as React from "react";

interface RefProps {
    color?: string;
    size?: number;
    fill?: string
}

const GalleryIcon = React.forwardRef<SVGSVGElement,RefProps>(({ color = 'currentColor', size = 24,fill='black', ...rest }, ref) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather" ref={ref} {...rest}>
            <rect width="16" height="16" rx="2" ry="2" y="1" x="7"></rect>
            <rect width="16" height="16" rx="2" ry="2" y="4" x="4" className="fill" ></rect>
            <rect width="16" height="16" rx="2" ry="2" y="7" x="1" className="fill"></rect>
        </svg>
    );
});

export default GalleryIcon;
